import React, { useEffect, useState } from "react";
import { getDomainConfig } from "../../config/config";
import { getLanguageCode } from "../../utils/getURLParams";
import { useTranslation } from "react-i18next";
import ExitPopUp from "../../utils/exitPopUp";

export function LogoPopUpMenu() {
  const config = getDomainConfig();
  const [showDetails, setShowDetails] = useState(false);
  const { t } = useTranslation("common")

  const handleToggleClick = (e) => {
    e.preventDefault();
    setShowDetails(!showDetails);
    ExitPopUp.Disable();
  };

  /* LOADING THE BRANDED SCSS */
  const [styles, setStyles] = useState(false);

  useEffect(() => {
    const getStyles = async (theFileName, theFileEnd) => {
      if (config.brand) {
        let moduleStyles = false;
        try {
          moduleStyles = await import(
            "./" + theFileName + config.brand + theFileEnd
          );
          setStyles(moduleStyles);
        } catch (e) {
          console.error(
            `Styles for ${theFileName} could not be loaded, ${e.message}`
          );
        }
      }
    };

    // Specify file name and end of file name here.
    getStyles("LogoPopUpMenu", ".module.scss");
  }, [config.brand]);

  /* END LOADING THE BRANDED SCSS */

  return (
    <>
      <a className={styles.homeClickMe} onClick={handleToggleClick}></a>
      {showDetails === true && (
        <>
          <div className={styles.popup}>
            <p className={styles.popupTitle}>
              {t('are-you-sure-you-want-to-return-home')}
            </p>
            <div className={styles.popupBtns}>
              <a
                className={styles.homeButton}
                href={`${config.brand === 'Uo' ? 'https://www.universalorlando.com/web/en/gb' : (config.brand === "Atd" ? `${window.location.origin}/${getLanguageCode(config.brand)}` : "/")}`}
              >
                {t('return-to-home')}
              </a>
            {config.brand !== "Atd" && <a className={styles.shoppingButton} href={`${config.brand === 'Uo' ? '/' : '#'}`}>
                Continue shopping
              </a>}
            </div>
          </div>
          <div className={styles.overlay} onClick={handleToggleClick}></div>
        </>
      )}
    </>
  );
}
